import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { SettingsScreen } from '../features/settings/SettingsScreen'

/** /settings — admin-страница «Настройки тенанта» (S44, D14 §«Настройки тенанта»).
 *  Permission-gating на самом экране: без distributor.settings.manage показываем
 *  warning Banner. Защищённый роут — обёрнут в <RequireAuth>. */
export const Route = createFileRoute('/settings')({
  component: SettingsRoute,
})

function SettingsRoute() {
  return (
    <RequireAuth>
      <SettingsScreen />
    </RequireAuth>
  )
}
